import { Logger } from '../../logger';

/// Adobe Analytics用のベースクラス
export abstract class Analytics {
  /// Adobe Analyticsのエラー時にログ出力して処理を進める
  run(f: (...args: any[]) => void) {
    try {
      f();
    } catch (e) {
      Logger.error(e);
    }
  }
}
